var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColAudioPlayXl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 41,
    viewBox: "0 0 3 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65594 0H1.40312C0.707837 0 0.144196 0.4515 0.144196 1.00845V39.9915C0.144196 40.5485 0.707837 41 1.40312 41H1.65594C2.35123 41 2.91486 40.5485 2.91486 39.9915V1.00845C2.91486 0.4515 2.35123 0 1.65594 0Z",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColAudioPlayXl);
export default __webpack_public_path__ + "static/media/col_audio_play_xl.ec31a64d0ebbe07512083a4e4aa53c88.svg";
export { ForwardRef as ReactComponent };